import Actor from "./Actor";

export default class Title extends Actor {
  get label() {
    return this._entity.label;
  }
}
